// icon:bx-building-house | Boxicons https://boxicons.com/ | Atisa
import * as React from "react";
import Icon from "../../images/art/icons/Country.png";

function IconBxBuildingHouse(props) {
	return (
		<img src={Icon} style={{ height: '1em', width: '1em', ...props }} alt={"Country"} />
	)
}

export default IconBxBuildingHouse;
